/**
 * reference: https://upmostly.com/tutorials/how-to-use-the-usecontext-hook-in-react
 */
import React, { useState } from 'react';

const ItemListContext = React.createContext([{}, () => {}]);

const ItemListProvider = (props) => {
    const [state, setState] = useState({
        isLoading: false,
        isLoaded: false,
        hasActiveRequest: false,
        lists: [],
    });

    return (
        <ItemListContext.Provider value={[state, setState]}>
            {props.children}
        </ItemListContext.Provider>
    );
};

export { ItemListContext, ItemListProvider };